import $foreign from "./foreign.cjs";
var none = $foreign.none;
export { none };
